import React, { Component, Fragment } from 'react';
import KeyboardEventHandler from 'react-keyboard-event-handler';
import { login, logout, loggedIn, whenLoggedIn } from './PhotosRest';

import closeIcon from './close.svg';

export default class LogInOut extends Component {
    constructor(props) {
	super(props);
	this.state = {
	    userlevel: 0,
	    showLogin: props.showLogin,
	    loginFailed: false,
	    username: '',
	    password: ''
	}
    }

    handleLogin = async () => {
	const success = await login(this.state.username, this.state.password);
	if (success) {
	    this.setState({
		loggedIn: true,
		loginFailed: false
	    });
	    this.props.toggle();
	    this.props.parentUpdate();
	    whenLoggedIn(u => this.setState({ userlevel: u.levelId }));
	} else {
	    this.setState({ loginFailed: true });
	}
    }

    handleLogout = async () => {
	logout();
	this.setState({
	    loggedIn: false
	});
	this.props.toggle();
	this.props.parentUpdate();
    }

    updateUsername = e => this.setState({ username: e.target.value });
    updatePassword = e => this.setState({ password: e.target.value });

    handleKeys = (key, event) => {
	if (key === 'esc') {
	    this.props.toggle();
	    event.preventDefault();
	    return;
	}
	if (key === 'enter') {
	    this.handleLogin();
	    event.preventDefault();
	    return;
	}
    }

    render() {
	const showLogin = this.props.showLogin;
	return (<Fragment>
		{ !showLogin && loggedIn()
		  ? <div className='loginout' onClick={this.handleLogout}>Logout</div>
		  : <div className='loginout' onClick={this.props.toggle}>Login</div> }
		{ showLogin &&
		  <div className='loginout'>
		  Login
		  { this.state.loginFailed && <span className='failedLogin'>failed</span> }
		  <img src={closeIcon} className='close' alt='close' onClick={this.props.toggle}/>
		  <table className='login'>
		  <tbody>
		  <tr className='username'>
		  <td>Username:</td>
		  <td><input type='text' className='username' defaultValue={this.state.username} onChange={this.updateUsername} autoFocus/></td>
		  </tr>
		  <tr className='password'>
		  <td>Password:</td>
		  <td><input type='password' className='password' defaultValue={this.state.password} onChange={this.updatePassword}/></td>
		  </tr>
		  <tr><td rowSpan="2">
		  <button type='button' id='login' onClick={this.handleLogin}>Login</button>
		  </td></tr>
		  </tbody>
		  </table>
		  <KeyboardEventHandler
		  handleKeys={['esc', 'enter']}
		  onKeyEvent={this.handleKeys}
		  handleFocusableElements={true}
		  isExclusive={true}/>
		  </div> }
		</Fragment>);
    }
}
